import { useState, useEffect } from 'react'
import { Box, Avatar } from '@mui/material'
import { useHistory } from 'react-router-dom'
import defaultImage from '../../images/default-image.svg'
import SysAdminUserActionBtn from '../Buttons/SysAdminUserActionBtn.jsx'
import { userButtonList } from '../utils/buttonList'

const SysAdminUsersCard = ({ data }) => {
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''

  const history = useHistory()
  const [status, setStatus] = useState(null)
  useEffect(() => {
    if (data?.active) setStatus(userButtonList[0])
    else setStatus(userButtonList[1])
  }, [data])

  const userProfileHandler = () => {
    history.push(`${baseUri}/user/${data.id}`)
  }

  return (
    <Box sx={styles.singleCard}>
      <Box sx={styles.info} onClick={userProfileHandler}>
        <Avatar alt="profileImage" sx={styles.profileImage} src={defaultImage} />

        <Box sx={styles.infoContainer}>
          <span>User Name</span>
          {data?.name ? data?.name : 'No User Name'}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>E-mail Address</span>
          {data?.email ? data?.email : '---'}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>Company</span>
          {data?.company?.name}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>User Type</span>
          {data?.user_types}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>Status</span>
          <Box sx={{ color: status?.color }}>{status?.title}</Box>
        </Box>
      </Box>

      <SysAdminUserActionBtn
        data={data}
        status={status}
        statusButtonList={userButtonList}
        route={`edit-user/${data?.id}`}
      />
    </Box>
  )
}

const styles = {
  singleCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    fontSize: { xs: '14px', md: '16px' },
    padding: '20px',
    paddingRight: { xs: '0px', md: '50px' },
    margin: '10px 0',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    width: '100%',
    position: { xs: 'relative', sm: 'unset' },

  },
  info: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    width: { xs: '90%', sm: '100%' },
    cursor: 'pointer',
  },

  profileImage: {
    display: { xs: 'none', sm: 'block' },
    width: { sm: 50, md: 70 },
    height: { sm: 50, md: 70 },
    marginBottom: { xs: '10px', sm: 'unset' },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    justifyContent: { xs: 'flex-start', sm: 'center' },
    width: '100%',
    alignItems: 'flex-start',
    fontSize: { xs: '10px', sm: '14px', md: '16px' },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    span: {
      display: 'block',
      width: 'fit-content',
      fontSize: { xs: '10px', sm: '14px', md: '16px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', sm: '0px' },
    },
  },
}
export default SysAdminUsersCard
